export const typesDefination = {
  b: 'Business Personal',
  m: 'Mobile',
  p: 'Personal',
  r: 'Real Estate',
  s: 'Special Assessment',
  u: 'Utility',
};

export default { typesDefination };
